






































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Getter } from 'vuex-class'
import { Prop } from 'vue-property-decorator'

// import DigitalCurrency5AccountThumbnail from '../../digital-currency-account/account-thumbnail/index.vue'
// import DigitalCurrency7ccountBalanceNumberWithIcon from '../../digital-currency-account/account-balance-number-with-icon/index.vue'
// import Input1TextInputForSearch from '../../../../website/data-structures/text-input-for-search/index.vue'

import QRCode from 'qrcode'

import { getDigitalCurrencyAmountWithCommaSeparatedValue } from '../service-for-helper-algorithms/helper-algorithms-2-get-digital-currency-amount-with-comma-separated-value'

const namespace = 'digitalCurrency'

@Component({
  components: {
    // DigitalCurrency5AccountThumbnail,
    // DigitalCurrency7ccountBalanceNumberWithIcon,
    // Input1TextInputForSearch
  }
})
class DigitalCurrencyTransaction2TransactionShortIntroduction extends Vue {

  @Prop({ default: '' }) transactionId?: string

  @Getter('getDigitalCurrencyTransaction', { namespace }) getDigitalCurrencyTransaction?: any

  transactionQRCodeDataUrl: string = ''

  isCopiedTextList: boolean[] = [false, false]

  getDigitalCurrencyAmountWithCommaSeparatedValue = getDigitalCurrencyAmountWithCommaSeparatedValue

  get isAdministratorTransaction (): boolean {
    return this.getDigitalCurrencyTransaction(this.transactionId).specialTransactionType
  }

  get digitalCurrencyTransaction () {
    return this.getDigitalCurrencyTransaction(this.transactionId)
  }

  async mounted () {
    this.transactionQRCodeDataUrl = await QRCode.toDataURL(this.digitalCurrencyTransaction.transactionId || 'default')
  }

  copyText (textValue: string, textIndex: number) {
    navigator.clipboard.writeText(textValue).catch((_errorMessage: any) => { /* */ })

    if (!textIndex && textIndex !== 0) {
      return
    }

    Vue.set(this.isCopiedTextList, textIndex, true)

    setTimeout(() => {
      Vue.set(this.isCopiedTextList, textIndex, false)
    }, 1000)
  }

  // Emit Toggle show content
  emitToggleShowContent ({ isVisible }: { isVisible: boolean }) {
    this.$emit('toggleShowContent', { isVisible })
  }
}

export default DigitalCurrencyTransaction2TransactionShortIntroduction


